import type { PropsWithChildren } from 'react';

import { ImagesGallery } from '@/components/ImagesGallery';
import ZipWidget from '@/components/ProductDetail/components/ZipWidget';
import { Row } from '@/components/Row';
import { generateDataTestId } from '@/lib/tests';

import {
  Breadcrumbs,
  CTA,
  Description,
  DetailsCard,
  PriceInformation,
  SecondaryCTA,
  StickyPurchaseBar,
} from './components';
import { AffirmSentence } from './components/AffirmSentence';
import { AgosSentence } from './components/AgosSentence';
import { CembraSentence } from './components/CembraSentence';
import { CreditPlusSentence } from './components/CreditPlusSentence';
import { OneySentence } from './components/OneySentence';
import { OricoFinancingSentence } from './components/OricoFinancingSentence';
import { SmbcSentence } from './components/SmbcSentence';
import { V12Sentence } from './components/V12Sentence';
import YourAssetWidget from './components/YourAsset';

import * as S from './ProductDetail.styles';

const ProductDetail = ({ children }: PropsWithChildren) => {
  return (
    <S.Wrapper
      {...generateDataTestId('productDetail', 'wrapper')}
      data-test-id='ProductDetailWrapper'
    >
      <S.Container>
        <Row data-test-id='ProductDetailRow' gapDensity='none'>
          {children}
        </Row>
      </S.Container>
    </S.Wrapper>
  );
};

ProductDetail.Name = S.Name;
ProductDetail.PromotedName = S.PromotedName;
ProductDetail.Pricing = S.Pricing;
ProductDetail.Description = Description;
ProductDetail.Sku = S.Sku;
ProductDetail.Divider = S.Divider;
ProductDetail.DetailsCard = DetailsCard;
ProductDetail.CTA = CTA;
ProductDetail.PriceInformation = PriceInformation;
ProductDetail.ImagesGallery = ImagesGallery;
ProductDetail.SecondaryCTA = SecondaryCTA;
ProductDetail.StickyPurchaseBar = StickyPurchaseBar;
ProductDetail.Breadcrumbs = Breadcrumbs;
ProductDetail.TaxLabel = S.TaxLabel;
ProductDetail.AffirmSentence = AffirmSentence;
ProductDetail.BoutiquePickUp = S.BoutiquePickUp;
ProductDetail.FinancingGroup = S.FinancingGroup;
ProductDetail.CembraSentence = CembraSentence;
ProductDetail.OneySentence = OneySentence;
ProductDetail.CreditPlusSentence = CreditPlusSentence;
ProductDetail.V12Sentence = V12Sentence;
ProductDetail.OricoFinancing = OricoFinancingSentence;
ProductDetail.AgosSentence = AgosSentence;
ProductDetail.ZipWidget = ZipWidget;
ProductDetail.Smbc = SmbcSentence;
ProductDetail.YourAssetWidget = YourAssetWidget;

export { ProductDetail };
